import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login";
import Layout from "../components/Layout";
import ApiCall from "../services/apiCall";
import Hero from "../components/Hero";
import { ToastContainer, toast } from "react-toastify";

const SignUp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [loading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoadingGoogle, setLoadingGoogle] = useState(false);
  const [isPhoneNumber, setIsPhoneNumber] = useState({
    active: true,
    value: "",
  });

  const onPressSignUp = async () => {
    // Email validation
    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    if (!emailRegex.test(email)) {
      toast.error(`Invalid email, Please enter a valid email address.`);
      return;
    }
    // Password validation
    const minPasswordLength = 6;
    if (confirmPassword.length < minPasswordLength) {
      toast.error(
        `Invalid password, It must be at least ${minPasswordLength} characters long.`
      );
      return;
    }
    if (confirmPassword === password) {
      const data = {
        email: email,
      };
      setIsLoading(true);
      try {
        const res = await ApiCall("api/send-otp", "POST", JSON.stringify(data));
        if (res.ok == true) {
          toast.success(
            typeof res?.message == "string"
              ? res?.message
              : "Something went wrong"
          );
          navigate("/otp", {
            state: {
              value: email,
              password: password,
            },
          });
        } else {
          toast.error(
            typeof res?.message == "string"
              ? res?.message
              : "Something went wrong"
          );
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.error(
        `Passwords don't match, Please make sure the passwords match.`
      );
    }
  };

  const onSingInWithGmail = useGoogleLogin({
    onSuccess: (response) => onSuccess(response),
    onError: (error) => onError(error),
    scope: "profile email",
  });

  const onError = (res) => {
    console.log("Login failed: res:", res);
    alert(`Failed to login. 😢 Please ping this to support: ${res.details}`);
  };

  const fetchGoogleUserProfile = async (accessToken) => {
    try {
      const res = await fetch("https://www.googleapis.com/oauth2/v2/userinfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const userInfo = await res.json();
      console.log(userInfo);
      return userInfo;
    } catch (error) {
      console.error("Error fetching Google user profile:", error);
    }
  };

  const onSuccess = (response) => {
    const accessToken = response.access_token;
    try {
      fetchGoogleUserProfile(accessToken).then((userInfo) => {
        const data = {
          name: userInfo.name,
          firstName: userInfo.given_name,
          lastName: userInfo.family_name,
          email: userInfo.email,
          username: userInfo.email,
          profilePhotoUrl: userInfo.picture,
          accessToken: accessToken,
          accessTokenExpiresAt: "",
        };
        console.log("User Data:", data);
        ApiCall("api/oauth/google", "POST", JSON.stringify(data))
          .then((res) => {
            if (res?.ok == true) {
              localStorage.setItem("userData", JSON.stringify(res?.data));
              localStorage.setItem(
                "userToken",
                JSON.stringify(res?.meta?.token)
              );
              navigate("/");
            }
          })
          .catch((error) => {
            toast.error(error?.message);
          });
      });
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const responseFacebook = (response) => {
    console.log(response);
  };

  return (
    <Layout>
      <Hero title="Sign Up" />
      {/* SignUp Section */}
      <section
        className="login-section section-gap wow fadeInUp"
        data-wow-delay="0.3s"
      >
        <div className="midd-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-sec">
                <h2 className="title-30 wow fadeInUp" data-wow-delay="0.2s">
                  Sign Up
                </h2>
              </div>
              <div className="form-sec">
                <form className="wow fadeInUp" data-wow-delay="0.2s">
                  <div className="input-sec">
                    <input
                      type="email"
                      name=""
                      placeholder="Enter Your Email"
                      className="form-control"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="input-sec mt-4">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Create Password"
                      className="form-control"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      <i className={showPassword ? "fas fa-eye" : "fas fa-eye-slash"}></i>
                    </button>
                  </div>
                  <div className="input-sec mt-4">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Enter Password again"
                      className="form-control"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      aria-label={
                        showConfirmPassword
                          ? "Hide password"
                          : "Show password"
                      }
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    >
                      <i
                        className={
                          showConfirmPassword ? "fas fa-eye" : "fas fa-eye-slash"
                        }
                      ></i>
                    </button>
                  </div>
                  <div className="btn-sec">
                    <button
                      type="button"
                      className="btn"
                      onClick={onPressSignUp}
                    >
                      Sign Up
                    </button>
                  </div>
                </form>
                <div className="sign-option">
                  <span className="wow fadeInUp" data-wow-delay="0.2s">
                    <Link to="/signin" className="title-20">
                      Sign in with Mobile Number
                    </Link>
                  </span>
                  <p className="p-18 wow fadeInUp" data-wow-delay="0.2s">
                    Or Sign in with
                  </p>
                  <div className="sign-social-option">
                    <a
                      href="#"
                      className="wow fadeInUp"
                      data-wow-delay="0.2s"
                      onClick={onSingInWithGmail}
                    >
                      <i className="fab fa-google"></i>
                    </a>
                    <FacebookLogin
                      appId="152339711194724"
                      autoLoad={false}
                      fields="name,email,picture"
                      scope="public_profile,email"
                      callback={responseFacebook}
                      render={(renderProps) => (
                        <a
                          href="#"
                          className="wow fadeInUp"
                          data-wow-delay="0.2s"
                          onClick={renderProps.onClick}
                          style={{
                            display: "inline-block",
                            // color: "#3b5998",
                            textDecoration: "none",
                            fontSize: "16px",
                          }}
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      )}
                    />
                    {/* <a href="#" className="wow fadeInUp" data-wow-delay="0.2s">
                      <i className="fab fa-facebook-f"></i>
                    </a> */}
                    {/* <a href="#" className="wow fadeInUp" data-wow-delay="0.2s">
                      <i className="fab fa-apple"></i>
                    </a> */}
                  </div>
                  <span
                    className="sign-up-option wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <p>
                      Already have an account?{" "}
                      <Link to={"/signin"}>Sign In</Link>
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* SignUp Section End */}

      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
      <ToastContainer />
    </Layout>
  );
};

export default SignUp;
